var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 46",
    d: "M2.28266 10.7751L3.66728 4.77514C3.77198 4.32141 4.17601 4 4.64167 4H6.79507C7.42121 4 7.89334 4.56888 7.77795 5.18429L6.65295 11.1843C6.56426 11.6573 6.15129 12 5.67007 12H3.25705C2.61397 12 2.13806 11.4018 2.28266 10.7751Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 48",
    d: "M21.7173 10.7751L20.3327 4.77514C20.228 4.32141 19.824 4 19.3583 4H17.2049C16.5788 4 16.1067 4.56888 16.2221 5.18429L17.3471 11.1843C17.4357 11.6573 17.8487 12 18.3299 12H20.7429C21.386 12 21.8619 11.4018 21.7173 10.7751Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 47",
    d: "M6.75348 10.7943L8.01484 4.79427C8.11215 4.33139 8.52045 4 8.99345 4H11C11.5523 4 12 4.44772 12 5V11C12 11.5523 11.5523 12 11 12H7.73209C7.09703 12 6.62283 11.4157 6.75348 10.7943Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M17.2465 10.7943L15.9852 4.79427C15.8878 4.33139 15.4795 4 15.0066 4H13C12.4477 4 12 4.44772 12 5V11C12 11.5523 12.4477 12 13 12H16.2679C16.903 12 17.3772 11.4157 17.2465 10.7943Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M5 12V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M10 19.5V17C10 16.4477 10.4477 16 11 16H13C13.5523 16 14 16.4477 14 17V19.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.d9648e8e05223a825fe1ad7ab5a2d09c.svg";
export { ForwardRef as ReactComponent };